import { render, staticRenderFns } from "./headerWorld.vue?vue&type=template&id=7e4c4062&scoped=true"
import script from "./headerWorld.vue?vue&type=script&lang=js"
export * from "./headerWorld.vue?vue&type=script&lang=js"
import style0 from "./headerWorld.vue?vue&type=style&index=0&id=7e4c4062&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4c4062",
  null
  
)

export default component.exports